// extracted by mini-css-extract-plugin
module.exports = {"modalDialog":"styles_modalDialog__1ytbE","inputsborder":"styles_inputsborder__2CW0_"};